import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { InvitationAcceptPage } from "@/pages"

const invitationAcceptSearchSchema = z.object({
  token: z.string().uuid(),
})

export const Route = createFileRoute(
  "/_authenticated/_account/invitations/$invitationUuid/"
)({
  component: InvitationAcceptPage,
  validateSearch: invitationAcceptSearchSchema,
})
